import { render, staticRenderFns } from "./AreaCode.vue?vue&type=template&id=1efc72da&"
import script from "./AreaCode.vue?vue&type=script&lang=js&"
export * from "./AreaCode.vue?vue&type=script&lang=js&"
import style0 from "./AreaCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1efc72da')) {
      api.createRecord('1efc72da', component.options)
    } else {
      api.reload('1efc72da', component.options)
    }
    module.hot.accept("./AreaCode.vue?vue&type=template&id=1efc72da&", function () {
      api.rerender('1efc72da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/AreaCode.vue"
export default component.exports